import * as React from 'react';
import {Button} from 'ukas.uux.react-components';
// const PearsonElementsSDK = require('@pearson-components/elements-sdk/build/dist.elements-sdk');
interface ConfirmationModalProps {
    cancelBtnHandler : ( event: React.UIEvent<HTMLSpanElement>) => void;
    successBtnHandler : ( event: React.UIEvent<HTMLSpanElement>) => void;
}


const ResetConfirmationModal = ({ successBtnHandler, cancelBtnHandler }: ConfirmationModalProps) =>{
  return ( 
    <div>
      <div >
      <span>Any changes made to the sample request will be reset, and the previously selected units/learners will be reinstated.</span>
      <br /><br />
      <span>Do you want to proceed?</span>
      </div>
      
      <div className="pull-right"><br /><br />
      <Button
            onClick={cancelBtnHandler.bind(event)}
            
            // disabled={isDisabled ? "disabled" : ""}
            >
            Cancel
            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="primary" onClick={successBtnHandler.bind(event)}>
            Ok
        </Button>
        <br /><br />
            
        
      </div>
    </div>
     
      
   
  );
};

export default ResetConfirmationModal;
